import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const loc = useLocation();
  const from = loc.state?.from;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    const res = await login(email.trim(), password);
    setLoading(false);
    if (!res.ok) {
      setErr(res.error);
      toast.error(res.error);
      return;
    }
    toast.success("Welcome back!");
    const target = res.user.role === "admin" ? "/admin" : from || "/dashboard";
    navigate(target, { replace: true });
  };

  return (
    <PublicLayout>
      <section className="py-16 sm:py-24">
        <div className="mx-auto max-w-md px-4 sm:px-6">
          <div className="rounded-2xl border border-[#E5E2DE] bg-white p-8 shadow-sm">
            <div className="mb-2 text-xs font-semibold uppercase tracking-[0.15em] text-[#E87722]">Welcome back</div>
            <h1 className="font-heading text-3xl font-bold text-ink">Sign in</h1>
            <p className="mt-2 text-sm text-ink-soft">Access your loan applications and repayments.</p>

            <form onSubmit={handleSubmit} className="mt-6 space-y-4" data-testid="login-form">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" data-testid="login-email" />
              </div>
              <div>
                <Label htmlFor="password">Password</Label>
                <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" data-testid="login-password" />
              </div>
              {err && <div className="rounded-lg bg-rose-50 px-3 py-2 text-sm text-rose-700" data-testid="login-error">{err}</div>}
              <Button type="submit" disabled={loading} className="w-full bg-[#5B2C82] text-white hover:bg-[#46225f]" data-testid="login-submit">
                {loading ? "Signing in…" : "Sign in"}
              </Button>
            </form>
            <div className="mt-5 text-center text-sm text-ink-soft">
              Don't have an account?{" "}
              <Link to="/register" className="font-semibold text-[#5B2C82] hover:text-[#E87722]" data-testid="login-register-link">
                Create one
              </Link>
            </div>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
